import { useEffect, useState } from 'react';
import { Info, Smartphone, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router';
import { platformConfig } from '../config/platform';
import { settingsService } from '../services/settingsService';
import logo from '@/assets/599ad72d49c8887573a4750887df95ce60e36150.png';

const PROFILE_SETTINGS_KEY = 'settings_company_profile';

export function About() {
  const showAndroidStore = platformConfig.os !== 'ios';
  const showIosStore = platformConfig.os !== 'android';
  const [profileUrls, setProfileUrls] = useState<{ googlePlayUrl: string; appStoreUrl: string }>({ googlePlayUrl: '', appStoreUrl: '' });

  useEffect(() => {
    settingsService.getPublicSettingValue<any>(PROFILE_SETTINGS_KEY, {}).then((data) => {
      setProfileUrls({
        googlePlayUrl: data?.googlePlayUrl || import.meta.env.VITE_GOOGLE_PLAY_URL || '',
        appStoreUrl: data?.appStoreUrl || import.meta.env.VITE_APP_STORE_URL || '',
      });
    }).catch(() => {});
  }, []);

  const googlePlayUrl = profileUrls.googlePlayUrl;
  const appStoreUrl = profileUrls.appStoreUrl;

  return (
    <div className="min-h-screen bg-slate-100 py-10 px-4 text-slate-900">
      <div className="w-full bg-white rounded-3xl shadow-sm border border-slate-300 overflow-hidden">
        <div style={{ background: 'linear-gradient(to right, #047857, #0f766e)' }} className="text-white p-8">
          <div className="flex items-center justify-between gap-4 mb-6">
            <Link to="/driver-mobile-auth" className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-medium hover:bg-white/20 transition-colors">
              <ArrowLeft className="w-4 h-4" /> Geri Dön
            </Link>
            <img src={logo} alt="Yük Ortağım Logo" className="h-14 w-auto bg-white rounded-2xl p-2 shadow-sm" />
          </div>
          <div className="flex items-center gap-3 mb-3">
            <Info className="w-8 h-8" />
            <h1 className="text-3xl font-bold">Yük Ortağım Hakkında</h1>
          </div>
          <p className="text-emerald-50 max-w-3xl">Yük Ortağım; tedarik yönetimi, sürücü operasyonları, teklif süreçleri, dış tedarik muhasebe ve mobil saha yönetimini tek platformda birleştiren lojistik yönetim çözümüdür.</p>
        </div>

        <div className="p-8 space-y-8">
          <section className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="rounded-2xl border border-slate-300 p-5 bg-slate-50 shadow-sm">
              <h2 className="font-semibold text-slate-900 mb-2">Operasyon Yönetimi</h2>
              <p className="text-sm leading-6 text-slate-700">Sevkiyat oluşturma, teklif toplama, araç ve sürücü planlama süreçlerini tek merkezden yönetin.</p>
            </div>
            <div className="rounded-2xl border border-slate-300 p-5 bg-slate-50 shadow-sm">
              <h2 className="font-semibold text-slate-900 mb-2">Mobil Sürücü Deneyimi</h2>
              <p className="text-sm leading-6 text-slate-700">Sürücüler teklif, sevkiyat takibi, belge yükleme, muhasebe ve destek süreçlerini mobil uygulamadan yönetebilir.</p>
            </div>
            <div className="rounded-2xl border border-slate-300 p-5 bg-slate-50 shadow-sm">
              <h2 className="font-semibold text-slate-900 mb-2">Muhasebe ve Kontrol</h2>
              <p className="text-sm leading-6 text-slate-700">Teslim evrakı, fatura, ödeme emri ve dekont süreçlerini dijital akışla takip edin.</p>
            </div>
          </section>

<section className="rounded-3xl border border-blue-300 bg-blue-50 p-8 shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <Smartphone className="w-6 h-6 text-blue-700" />
              <h2 className="text-2xl font-bold text-blue-900">Mobil Uygulamayı İndir</h2>
            </div>
            <p className="mb-6 text-blue-900">Sürücü uygulamasını indirerek tekliflerinizi mobil cihazınızdan takip edebilir, teslimat detaylarını görüntüleyebilir ve güncel kalabilirsiniz.</p>
            
            <div className={`grid grid-cols-1 ${showAndroidStore && showIosStore ? 'md:grid-cols-2' : ''} gap-4`}>
              {showAndroidStore && <div className="rounded-2xl border border-slate-200 bg-white p-6">
                <div className="flex items-center gap-4 mb-4">
                  <svg viewBox="0 0 24 24" className="w-14 h-14">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                  </svg>
                  <div>
                    <h3 className="font-semibold text-slate-900">Android</h3>
                    <p className="text-sm text-slate-500">Google Play Store</p>
                  </div>
                </div>
                {googlePlayUrl ? (
                  <a href={googlePlayUrl} target="_blank" rel="noreferrer" className="block w-full text-center py-3 bg-green-600 text-white font-medium rounded-xl hover:bg-green-700 transition-colors">
                    Google Play'den İndir
                  </a>
                ) : (
                  <div className="rounded-xl bg-gray-100 p-3 text-center text-sm text-gray-500">
                    URL yapılandırılmadı
                  </div>
                )}
              </div>}

              {showIosStore && <div className="rounded-2xl border border-slate-200 bg-white p-6">
                <div className="flex items-center gap-4 mb-4">
                  <svg viewBox="0 0 24 24" className="w-14 h-14">
                    <path fill="currentColor" d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                  </svg>
                  <div>
                    <h3 className="font-semibold text-slate-900">iOS</h3>
                    <p className="text-sm text-slate-500">Apple App Store</p>
                  </div>
                </div>
                {appStoreUrl ? (
                  <a href={appStoreUrl} target="_blank" rel="noreferrer" className="block w-full text-center py-3 bg-green-600 text-white font-medium rounded-xl hover:bg-green-700 transition-colors">
                    App Store'dan İndir
                  </a>
                ) : (
                  <div className="rounded-xl bg-gray-100 p-3 text-center text-sm text-gray-500">
                    URL yapılandırılmadı
                  </div>
                )}
              </div>}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
